const LAZY_IMAGE_SELECTOR = 'img[data-mda-lazy-image]';
const ROOT_MARGIN = '200px 0px';

const restoreAttribute = (image, attribute, dataAttribute) => {
    const value = image.getAttribute(dataAttribute);

    if (!value) return;

    image.setAttribute(attribute, value);
    image.removeAttribute(dataAttribute);
};

const loadImage = (image, observer = null) => {
    if (!image.matches(LAZY_IMAGE_SELECTOR)) return;

    observer?.unobserve(image);

    // Restore responsive image data before src so the browser can choose the
    // correct resource without first downloading the fallback candidate.
    restoreAttribute(image, 'sizes', 'data-mda-sizes');
    restoreAttribute(image, 'srcset', 'data-mda-srcset');
    restoreAttribute(image, 'fetchpriority', 'data-mda-fetchpriority');
    restoreAttribute(image, 'src', 'data-mda-src');

    image.removeAttribute('data-mda-lazy-image');
};

export const initLazyImages = () => {
    const images = document.querySelectorAll(LAZY_IMAGE_SELECTOR);

    if (!images.length) return;

    if (!('IntersectionObserver' in window)) {
        images.forEach(image => loadImage(image));
        return;
    }

    const observer = new IntersectionObserver(
        entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    loadImage(entry.target, observer);
                }
            });
        },
        {
            rootMargin: ROOT_MARGIN,
            threshold: 0.01,
        }
    );

    images.forEach(image => observer.observe(image));
};
